// `kind` is the `payment/list` filter to send: undefined lists both kinds (All), a kind lists one
// (Payments, Refunds). `null` means Write-offs, which sends no request at all.
export const CLIENT_BILLING_ACTIVITY_FILTER_OPTIONS = [
    { value: 'all', label: 'All', kind: undefined },
    { value: 'payments', label: 'Payments', kind: 'PAYMENT' },
    { value: 'refunds', label: 'Refunds', kind: 'REFUND' },
    { value: 'write-offs', label: 'Write-offs', kind: null },
] as const;

export type ActivityFilterValue = (typeof CLIENT_BILLING_ACTIVITY_FILTER_OPTIONS)[number]['value'];
